<template>
  <div class="login-box">
    <div class="ipt-group" :class="{ error: $v.form.phone.$error }">
      <input type="text" v-model.trim="form.phone" />
      <p class="sub-text" :class="{ 'has-text': form.phone }">手机号</p>
      <div class="line" :style="`background:${theme.themeColor}`"></div>
      <vd-tips path="form.phone" class="error-tip" />
    </div>
    <div class="code-container">
      <div
        class="ipt-group code-group"
        :class="{ error: $v.form.code.$error }"
      >
        <input type="text" v-model.trim="form.code" />
        <p class="sub-text" :class="{ 'has-text': form.code }">验证码</p>
        <div class="line" :style="`background:${theme.themeColor}`"></div>
        <vd-tips path="form.code" class="error-tip" />
      </div>
      <countdown-btn
        class="code-btn"
        el="button"
        ref="loginCapchaBtn"
        :style="`'background: ${theme.themeSubColor}color: ${theme.themeColor}`"
        placeholder="获取验证码"
        lockTmp="%s秒后重新发送"
        clickTips="正在获取验证码"
        @click="getCode"
      ></countdown-btn>
    </div>
    <el-button
      class="btn-login"
      :style="`background:${theme.buttonBackground}box-shadow:${theme.buttonShadow}`"
      :loading="loading"
      @click="login"
    >{{ loading ? '登录中' : '登录' }}</el-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Button } from 'element-ui'
import { required, validationMixin, phone } from '@/utils/mixin_validate'
import CountdownBtn from '@/components/CountdownBtn'

/**
 * 手机号+验证˚码登录
 */
export default {
  components: {
    ElButton: Button,
    CountdownBtn
  },
  mixins: [validationMixin()],
  validations() {
    // 定义检验规则时注意顺序，弹窗模式时将按顺序弹窗
    return {
      form: {
        phone: {
          required,
          phone
        },
        code: {
          required
        }
      }
    }
  },
  validators: {
    // 这里定义错误提示，与validations结构一一对应
    form: {
      phone: {
        required: '请输入正确的手机号',
        phone: '请输入正确的手机号'
      },
      code: {
        required: '请输入验证码'
      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        phone: '',
        code: ''
      }
    }
  },
  computed: {
    ...mapState(['theme', 'captchaCb'])
  },
  watch: {
    captchaCb(newVal) {
      const countdownBtn = this.$refs.loginCapchaBtn
      if (newVal === 'lock') {
        countdownBtn.lock()
      } else if (newVal === 'reset') {
        countdownBtn.reset()
      }
    }
  },
  methods: {
    async getCode(lock, reset) {
      reset()
      this.$v.form.phone.$touch()
      const tip = this._getValidatorError(this.$v.form.phone)
      if (tip.tips !== '未知错误') {
        return
      }
      this.$store.commit('SETSTATE', [
        { key: 'captchaType', value: 'login_captcha' },
        { key: 'phoneNum', value: this.form.phone }
      ])
      await this.$store.dispatch('getCaptchaInit', 'egLIJPgY')
      this.$store.state.captcha.show()
    },
    async login() {
      try {
        await this.validationTouch()
        this.loading = true
        const { phone, code } = this.form
        const { user_info } = await this.$auth('login_phone', ...[phone.trim(), code.trim()])
        localStorage.setItem('currentAccount', '')
        localStorage.setItem('currentPhone', phone)
        await this.$emit('success', user_info)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$emit('fail', e)
      }
    }
  }
}
</script>

<style lang="scss">
@import './index.scss';
</style>
<style lang="scss" scoped>
.code-container {
  display: flex;
  .code-group {
    flex: auto;
    margin-bottom: 0;
  }
  .code-btn {
    cursor: pointer;
    margin: 22px 0 0 20px;
    width: 130px;
    height: 42px;
    background: $themeSubColor;
    border-radius: 4px;
    color: $themeColor;
    font-size: 14px;
    font-weight: 300;
  }
}
</style>
